export class CertificateData {
  id?: number;
  landRegisterPage: string;
  department: string;
  serialNumber: string;
  certificate: string;
}
